<template>

  <b-row>
    <b-col md="2"><a href="https://sportips.fr" class=" text-white"><img class="logo_sportips_topbar mr-1"
          src="../../assets/sportips_logo.png" />Sportips</a></b-col>
    <b-col md="8">
      <p class="text-white" style="margin-bottom: 0;">
        <v-icon style="color: #f29406" name="running" />
        <span style="font-weight: bold; font-size: 1.1em">Importation de résultats</span>
      </p>
    </b-col>
  </b-row>



</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },

};
</script>

<style scoped>
.logo_sportips_topbar {
  height: 25px;
  width: auto;
}
</style>
